import { render, staticRenderFns } from "./TazminatAlacakKalemiForm.vue?vue&type=template&id=7f67ca40"
import script from "./TazminatAlacakKalemiForm.vue?vue&type=script&lang=ts"
export * from "./TazminatAlacakKalemiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports